import dayjs from "dayjs";
import { createStore } from "@/vuex/store";
import { getBalance } from "@/api/api";
import { ElMessage } from "element-plus";
import { appId } from "@/utils/url";
import { generateHomeMenuList } from "@/common/menuService";

import router from "../router";

const store = createStore();
function addChatData(item: any) {
  // if (!localStorage.getItem("token")) return;
  store.action.updateUserList(item);
  // store.action.updatePrompt(item.introduction);
  if (item.type !== "WORKFLOW") {
    if (item.type === "AGENT_TEAM") {
      const data = {
        thoughtText: [{ data: item.introduction, type: "TEXT" }],
        person: 1,
        name: item.name,
        id: `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        headImageUrl: item.headImageUrl ? item.headImageUrl : item.avatar_url,
        date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      };
      const isFirst = true;
      store.action.updateChatData(item.id, data, isFirst);
    } else {
      const data = {
        person: 1,
        text: item.introduction,
        date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      };
      const isFirst = true;
      store.action.updateChatData(item.id, data, isFirst);
    }
  }
  store.action.repeatNowSelect(item);
}
function changeMember(val: string) {
  let title = "";
  switch (val) {
    case "FREE":
      title = "基础版";
      break;
    case "NORMAL":
      title = "标准版";
      break;
    case "PROFESSION":
      title = "专业版";
      break;
    case "ENTERPRISE":
      title = "企业版";
      break;
    case "CUSTOM":
      title = "定制版";
      break;
    default:
      title = "";
  }
  return title;
}
function addChatDataforWeb(item: any) {
  store.action.updateUserList(item);
  // store.action.updatePrompt(item.introduction);
  const data = {
    person: 1,
    text: item.introduction,
    date: dayjs().format("YYYY-MM-DD HH:mm:ss"),
  };
  const isFirst = true;
  store.action.updateChatData(item.id, data, isFirst);
  store.action.repeatNowSelect(item);
}

function updataBalance() {
  getBalance().then((res: any) => {
    if (res.code === 200) {
      store.action.updataBalance(res.data);
    }
  });
}

let isLoading = true;
function isToken() {
  if (localStorage.getItem("token")) {
    return true;
  } else {
    if (isLoading) {
      isLoading = false;
      const localHerf = window.location.href;
      const isPortal = localHerf.includes("portal");
      if (!isPortal) {
        ElMessage({
          type: "warning",
          message: "请先登录",
        });
      }
      const tiemet = setTimeout(() => {
        isLoading = true;
        clearInterval(tiemet);
      }, 1000);
    }
    return false;
  }
}
function weXinlogin() {
  const appid = appId;
  localStorage.setItem("isRedirectUri", "isRedirectUri");
  const redirect_uri = encodeURIComponent(window.location.href); // 跳转本页，注意访问url必须是 http://wwww.xxx.com
  const scope = "snsapi_userinfo";
  const state = "1";
  const url =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
    appid +
    "&redirect_uri=" +
    redirect_uri +
    "&response_type=code&scope=" +
    scope +
    "&state=" +
    state +
    "#wechat_redirect";
  window.location.href = url; // 这样浏览器回退时由于不带cookie，会重复授权
}
// function weXinlogin() {
//   WapDoAuth()
// }

// 匹配code
interface UrlParams {
  code: string;
  // 在这里定义其他参数的类型
}
function extractUrlParams(url: string): UrlParams | undefined {
  const regex = /\?code=([^&]*)/;
  const match = regex.exec(url);
  const code = match && decodeURIComponent(match[1].replace(/\+/g, " "));
  if (code) {
    return { code };
  }
}
// 匹配图片
function getImageUrl(str: string): string[] {
  // 确保 str 是一个有效的字符串
  if (typeof str !== "string") return [];

  // 保持原有代码块过滤逻辑
  const codeBlockRegex = /```[\s\S]*?```/g;
  const strippedMarkdown = str.replace(codeBlockRegex, "");

  // 增强版图片匹配规则
  const imageRegex =
    /(?:!\[.*?\]\()?(https?:\/\/[^\s]+?\.(?:png|jpe?g|webp|gif)(?=\?|$|\)|\s))/gi;

  const matches = [];
  let match;

  while ((match = imageRegex.exec(strippedMarkdown)) !== null) {
    matches.push(match[1] || match[0]); // 同时匹配纯 URL 和 Markdown 语法
  }
  return [...new Set(matches)]; // 去重处理
}
// 权限判断
function rightJudgment(str: string) {
  // 如果为企业版 则去判断其他都判断为true
  if (
    store.state.user.memberGrade === "ENTERPRISE" &&
    store.state.user.authorizedRoute
  ) {
    const permeerlist = store.state.user.authorizedRouteList;
    return permeerlist.includes(str);
  } else {
    return true;
  }
}

function getMp4Url(str: string) {
  if (typeof str !== "string") return [];

  // 移除代码块内容 (与 getImageUrl 保持相同逻辑)
  const codeBlockRegex = /```[\s\S]*?```/g;
  const strippedMarkdown = str.replace(codeBlockRegex, "");

  // 移除 Markdown 链接格式，避免提取超链接形式的 MP4
  const markdownLinkRegex = /\[([^\]]*)\]\(([^)]+)\)/g;
  const strippedLinks = strippedMarkdown.replace(markdownLinkRegex, "");

  // 增强版 MP4 匹配规则
  const regex = /https?:\/\/[^\s]+?\.mp4(?=\?|$|\)|\s)/gi;
  const matches = strippedLinks.match(regex) || [];

  return [...new Set(matches)]; // 去重处理
}

// 压缩图片
const fileToDataURL = (file: Blob): Promise<any> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e) => resolve((e.target as FileReader).result);
    reader.readAsDataURL(file);
  });
};
const dataURLToImage = (dataURL: string): Promise<HTMLImageElement> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.src = dataURL;
  });
};
const canvastoFile = (
  canvas: HTMLCanvasElement,
  type: string,
  quality: number
): Promise<Blob | null> => {
  return new Promise((resolve) =>
    canvas.toBlob((blob) => resolve(blob), type, quality)
  );
};
/**
 * 图片压缩方法
 * @param {Object}  file 图片文件
 * @param {String} type 想压缩成的文件类型
 * @param {Nubmber} quality 压缩质量参数
 * @returns 压缩后的新图片
 */
const compressionFile = async (
  file: any,
  type = "image/jpeg",
  quality = 0.5
) => {
  const fileName = file.name;
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d") as CanvasRenderingContext2D;
  const base64 = await fileToDataURL(file);
  const img = await dataURLToImage(base64);
  canvas.width = img.width;
  canvas.height = img.height;
  context.fillStyle = "#fff";
  context.fillRect(0, 0, canvas.width, canvas.height);
  // context.clearRect(0, 0, img.width, img.height)
  context.drawImage(img, 0, 0, img.width, img.height);
  const blob = (await canvastoFile(canvas, type, quality)) as Blob; // quality:0.5可根据实际情况计算
  const newFile = await new File([blob], fileName, {
    type: type,
  });
  return newFile;
};

function downloadFile(url: string, name?: string): void {
  const link = document.createElement("a");
  link.href = url;
  if (name) {
    link.setAttribute("download", name);
  } else {
    link.setAttribute("download", "");
  }
  link.click();
}

/**
 * 简单的流式下载方法（支持跨域）
 * @param url 文件URL
 * @param fileName 自定义文件名（可选）
 * @returns Promise<void>
 */
async function streamDownload(url: string, fileName?: string): Promise<void> {
  try {
    // 方案1：直接使用链接下载（推荐用于跨域文件）
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "download";
    link.target = "_blank";

    // 添加跨域属性
    link.setAttribute("crossorigin", "anonymous");

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("下载失败:", error);
    throw error;
  }
}

/**
 * 跨域流式下载方法（需要服务器支持CORS）
 * @param url 文件URL
 * @param fileName 自定义文件名（可选）
 * @returns Promise<void>
 */
async function crossOriginStreamDownload(
  url: string,
  fileName?: string
): Promise<void> {
  try {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors", // 启用CORS
      // credentials: 'omit', // 不发送cookies
      headers: {
        "Content-Type": "application/octet-stream",
      },
    });

    if (!response.ok) {
      throw new Error(`下载失败: ${response.status}`);
    }

    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = fileName || "download";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("跨域下载失败:", error);
    // 如果跨域失败，回退到直接链接下载
    console.log("回退到直接链接下载...");
    await streamDownload(url, fileName);
  }
}

/**
 * 通用下载方法（自动处理跨域问题）
 * @param url 文件URL
 * @param fileName 自定义文件名（可选）
 * @returns Promise<void>
 */
async function universalDownload(
  url: string,
  fileName?: string
): Promise<void> {
  try {
    // 首先尝试跨域下载
    await crossOriginStreamDownload(url, fileName);
  } catch (error) {
    console.log("跨域下载失败，使用直接链接下载:", error);
    // 如果跨域失败，使用直接链接下载
    await streamDownload(url, fileName);
  }
}

function truncateString(str: string) {
  if (str) {
    const maxLength = 2000;
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + "...";
    }
    return str;
  } else {
    return str;
  }
}
function getRouterName(routeList: string[]): string[] {
  // 使用小写的 string
  const routes = router.getRoutes(); // 假设 router 是全局可用的对象

  const matchedNames = routes
    .filter((route) => routeList.includes(route.path)) // 过滤出匹配的路由
    .map((route) => route.name) // 提取对应的 name
    .filter((name): name is string => name !== undefined); // 过滤掉 undefined

  return matchedNames; // 返回匹配的路由名称数组
}
// 检测图片地址是否可用
function checkImageExists(imageUrl: any, callback: any) {
  const img = new Image();
  img.onload = function () {
    callback(true);
  };
  img.onerror = function () {
    callback(false);
  };
  img.src = imageUrl;
}

function authIsShow(code: string) {
  if (localStorage.getItem("user")) {
    // store
    // const userDetail =
    // if (userDetail.authorizedRoute && ) {

    // }
    if (
      store.state.user.memberGrade === "ENTERPRISE" &&
      store.state.user.authorizedRoute
    ) {
      try {
        const permeerlist = store.state.user.authorizedRouteList;
        if (permeerlist.includes(code)) {
          return true;
        } else {
          return false;
        }
      } catch {
        return true;
      }
    } else {
      return true;
    }
  }
}

// OEM tenants can opt out of the member-grade badge in the top nav. Absent or
// falsy flag keeps the badge visible, so behaviour is unchanged for everyone
// the backend hasn't explicitly configured.
function showMemberGradeBadge() {
  return store.state.user?.companyHideMemberGrade !== true;
}

function parseMarkdownWithLaTeXHandling(text: string): string {
  let result = "";
  let inCodeBlock = false;
  const inTable = false;
  // 分割行来进行逐行解析
  try {
    const lines: string[] = text.split("\n");
    lines.forEach((line: string) => {
      // 检查是否在表格中
      const trimmedLine = line.trim();
      // if (trimmedLine.startsWith("|") || trimmedLine.match(/^\|.*\|$/)) {
      //   inTable = true;
      // } else if (trimmedLine === "" || (!trimmedLine.startsWith("|") && !trimmedLine.match(/^\|.*\|$/))) {
      //   inTable = false;
      // }

      if (trimmedLine.startsWith("```")) {
        inCodeBlock = !inCodeBlock;
        result += line + "\n";
        return;
      }
      if (inCodeBlock) {
        // 在代码块中，直接添加行
        result += line + "\n";
      } else if (inTable) {
        // 在表格中，更谨慎地处理 LaTeX
        let processedLine = line;

        // 只处理明确的 LaTeX 语法，避免误匹配表格中的 $ 符号
        processedLine = processedLine
          .replace(/\\\[/g, "$$")
          .replace(/\\\]/g, "$$")
          .replace(/\[/g, "$$")
          .replace(/\]/g, "$$")
          .replace(/\\\(/g, "$")
          .replace(/\\\)/g, "$");

        // 在表格中，只处理已经被转义的 LaTeX 语法，避免误匹配
        // 不处理普通的 $ 符号，因为它们可能是表格内容
        result += processedLine + "\n";
      } else {
        // 不在代码块和表格中，正常处理 LaTeX
        const processedLine: string = line
          .replace(/\\\[/g, "$$")
          .replace(/\\\]/g, "$$")
          .replace(/\\\(/g, "$")
          .replace(/\\\)/g, "$")
          .replace(/\$(.*?)\$/g, (match, p1) => `$${p1.trim()}$`)
          .replace(/\$\$(.*?)\$\$/g, (match, p1) => `$${p1.trim()}$$`);
        result += processedLine + "\n";
      }
    });
    return result;
  } catch (error) {
    console.log(error);
    return text;
  }
}
function deepClone<T>(obj: T, hash: WeakMap<object, any> = new WeakMap()): T {
  // 处理 null 或者不是对象的情况
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  // 将 obj 转换为 unknown，然后再转换为 object
  const objAsObject = obj as unknown as object;

  // 如果对象已经被克隆过，直接返回克隆结果，解决循环引用的问题
  if (hash.has(objAsObject)) {
    return hash.get(objAsObject);
  }

  // 处理日期对象
  if (obj instanceof Date) {
    return new Date(obj.getTime()) as unknown as T;
  }

  // 处理正则表达式对象
  if (obj instanceof RegExp) {
    return new RegExp(obj.source, obj.flags) as unknown as T;
  }

  // 创建一个新对象/数组作为克隆的基础
  const clonedObj: any = Array.isArray(obj) ? [] : {};

  // 将新对象存储到哈希表中，以处理循环引用
  hash.set(objAsObject, clonedObj);

  // 遍历对象的属性并进行递归克隆
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone((obj as any)[key], hash);
    }
  }
  return clonedObj as T;
}
interface UserDetail {
  authorizedRoute: boolean;
  authorizedRouteList: string[];
}
// 传入当前权益，需要的权益
function handlePrivige(val: string, needMem: string) {
  if (needMem === "FREE") {
    return true;
  } else if (needMem === "NORMAL") {
    if (val === "FREE") {
      return false;
    } else {
      return true;
    }
  } else if (needMem === "PROFESSION") {
    if (val === "FREE" || val === "NORMAL") {
      return false;
    } else {
      return true;
    }
  } else if (needMem === "ENTERPRISE" || needMem === "CUSTOM") {
    return true;
  }
}
function handleConsoleMenuList(userData: any) {
  let authorizedRoute = false; // 初始化 authorizedRoute
  let allowRouterName: string[] = []; // 初始化 allowRouterName
  const userString = localStorage.getItem("user");
  if (userString) {
    // 确保 userString 不是 null
    try {
      const userDetail: UserDetail = JSON.parse(userString) as UserDetail; // 解析并转换为 UserDetail 类型
      if (userDetail.authorizedRoute) {
        authorizedRoute = userDetail.authorizedRoute; // 赋值
        const allowList: string[] = userDetail.authorizedRouteList; // 使用具体类型
        const aaindex = allowList.findIndex((item) => {
          return item === "appTemplate";
        });
        if (aaindex !== -1) {
          allowList.splice(aaindex, 1, "/console/templates");
        }
        allowRouterName = getRouterName(allowList); // 调用函数
      }
    } catch (error) {
      console.error("解析用户数据时出错:", error);
    }
  }
  const menuList = [
    {
      name: "创造",
      id: "1",
      menu: [
        {
          name: "智能体",
          routerName: "myApp",
          isAvailable: true,
          hiddenMenu: false,
          id: "1-1",
          path: "/console/factory",
        },
        {
          name: "知识库",
          routerName: "knowledge",
          isAvailable: true,
          hiddenMenu: false,
          id: "1-2",
          path: "/console/knowledge",
        },
        {
          name: "数据库",
          routerName: "database",
          isAvailable: true,
          hiddenMenu: false,
          id: "1-3",
          path: "/console/database",
        },
        {
          name: "能力",
          routerName: "ability",
          isAvailable: true,
          hiddenMenu: false,
          id: "1-4",
          path: "/console/ability",
        },
        {
          name: "工作流",
          routerName: "flow",
          isAvailable: true,
          hiddenMenu: false,
          id: "1-5",
          path: "/console/workflows",
        },
      ],
    },
    {
      name: "接入",
      id: "2",
      menu: [
        {
          name: "渠道接入",
          routerName: "openInterface",
          isAvailable: true,
          hiddenMenu: false,
          id: "2-1",
          path: "/console/interface",
        },
        {
          name: "客户端",
          routerName: "clients",
          isAvailable: false,
          hiddenMenu: false,
          content: "标准版",
          id: "2-2",
          path: "/console/clients",
        },
        {
          name: "客户管理",
          routerName: "customManage",
          isAvailable: true,
          hiddenMenu: true,
          id: "2-3",
          path: "/console/customManage",
        },
        {
          name: "对话管理",
          routerName: "chatManage",
          isAvailable: false,
          hiddenMenu: false,
          content: "专业版",
          id: "2-4",
          path: "/console/chatManage",
        },
      ],
    },
    {
      name: "管理",
      id: "3",
      menu: [
        // { name: '返回首页', routerName: 'home' },
        {
          name: "我的账户",
          routerName: "myCenter",
          isAvailable: true,
          hiddenMenu: false,
          id: "3-1",
          path: "/console/account",
        },
        {
          name: "模型服务",
          routerName: "model",
          isAvailable: true,
          hiddenMenu: false,
          content: "标准版",
          id: "3-2",
          path: "/console/model",
        },
        {
          name: "数据看板",
          routerName: "dataAnalysis",
          isAvailable: true,
          hiddenMenu: false,
          content: "标准版",
          id: "3-3",
          path: "/console/dataAnalysis",
        },
        {
          name: "团队空间",
          routerName: "teamSpace",
          isAvailable: false,
          hiddenMenu: false,
          content: "专业版",
          id: "3-4",
          path: "/console/teamSpace",
        },
      ],
    },
    {
      name: "发现",
      id: "4",
      menu: [
        {
          name: "模板中心",
          routerName: "templateCenter",
          isAvailable: true,
          hiddenMenu: false,
          id: "4-1",
          path: "/console/templates",
        },
        {
          name: "应用广场",
          routerName: "home",
          isAvailable: true,
          hiddenMenu: false,
          id: "4-2",
          path: "/home",
        },
        {
          name: "内容创作",
          routerName: "contentCreation",
          isAvailable: true,
          hiddenMenu: true,
          id: "4-3",
          path: "/console/contentCreation",
        },
      ],
    },
  ];

  // 判断用户信息是否存在非空 companyStudioDomainName 字段
  let hasStudioDomain = false;
  try {
    const userInfoStr = localStorage.getItem("user");
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr);
      hasStudioDomain = !!(userInfo && userInfo.companyStudioDomainName);
    }
  } catch (error) {
    hasStudioDomain = false;
  }
  // 「内容创作」显示规则：非 OEM 用户（官方域名）始终展示；
  // OEM 用户仅当配置了 companyStudioDomainName 时才展示。
  const showContentCreation = judgementShwo() || hasStudioDomain;
  // 企业版按权限路由过滤菜单，需将「内容创作」加入白名单才能展示
  if (showContentCreation && !allowRouterName.includes("contentCreation")) {
    allowRouterName.push("contentCreation");
  }
  // "能力" holds the skill, MCP and plugin tabs, so the menu shows when any of them is granted.
  if (
    ["skillMarket", "mcpServers", "plugins"].some((name) => allowRouterName.includes(name)) &&
    !allowRouterName.includes("ability")
  ) {
    allowRouterName.push("ability");
  }

  if (userData.memberGrade === "ENTERPRISE") {
    if (authorizedRoute) {
      // const authorizedRoute = userDetail.authorizedRoute;
      // const allowList = userDetail.authorizedRouteList;
      // const allowRouterName = getRouterName(allowList);

      // allowRouterName.push("home");
      const newMenuList = menuList
        .map((category) => {
          const filteredMenu = category.menu.filter((item) =>
            allowRouterName.includes(item.routerName)
          );

          return {
            name: category.name,
            menu: filteredMenu,
            id: category.id,
          };
        })
        .filter((category) => category.menu.length > 0);
      newMenuList.forEach((item) => {
        item.menu.forEach((items) => {
          items.isAvailable = true;
        });
      });
      newMenuList.forEach((item) => {
        item.menu.forEach((items) => {
          if (items.routerName === "teamSpace") {
            items.name = "企业空间";
          }
          if (
            items.routerName === "customManage" &&
            userData.customerAdmin === "Y"
          ) {
            items.hiddenMenu = false;
          } else if (
            items.routerName === "customManage" &&
            userData.customerAdmin !== "Y"
          ) {
            items.hiddenMenu = true;
          }
          if (items.routerName === "contentCreation") {
            items.hiddenMenu = !showContentCreation;
          }
        });
      });
      return newMenuList;
    }
  } else {
    menuList.forEach((item) => {
      item.menu.forEach((items) => {
        if (items.routerName === "clients" && userData.clientManage > 0) {
          items.isAvailable = true;
        } else if (
          items.routerName === "chatManage" &&
          userData.customerManage > 0
        ) {
          items.isAvailable = true;
        } else if (
          items.routerName === "teamSpace" &&
          userData.memberNumber > 0
        ) {
          items.isAvailable = true;
        } else if (
          items.routerName === "customManage" &&
          (rightJudgment("customerList") || rightJudgment("tagManage")) &&
          userData.customerAdmin === "Y"
        ) {
          items.hiddenMenu = false;
        }
        if (items.routerName === "contentCreation") {
          items.hiddenMenu = !showContentCreation;
        }
      });
    });
    return menuList;
  }
}
function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay = 200
): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout>;

  return function (this: any, ...args: Parameters<T>): void {
    // 清除上一次的定时器
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    // 设置新的定时器
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
function convertImageLinksToMarkdown(text: string): string {
  if (typeof text !== "string") return text;

  // 检测 Markdown 代码块位置（```包围的内容）
  const codeBlockRegex = /```[\s\S]*?```/g;
  const codeBlockPositions: Array<{ start: number; end: number }> = [];

  let match;
  while ((match = codeBlockRegex.exec(text)) !== null) {
    codeBlockPositions.push({
      start: match.index,
      end: match.index + match[0].length,
    });
  }

  // 检测行内代码位置（`包围的内容）
  const inlineCodeRegex = /`[^`\n]+`/g;
  const inlineCodePositions: Array<{ start: number; end: number }> = [];

  while ((match = inlineCodeRegex.exec(text)) !== null) {
    inlineCodePositions.push({
      start: match.index,
      end: match.index + match[0].length,
    });
  }

  // 匹配 markdown 图片格式 ![alt](url) 和 markdown 链接格式 [text](url)
  const markdownImageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
  const markdownLinkRegex = /\[([^\]]*)\]\(([^)]+)\)/g;

  // 存储已处理的 markdown 格式位置，避免重复处理
  const processedPositions = new Set<number>();

  // 收集所有 markdown 格式的位置
  while ((match = markdownImageRegex.exec(text)) !== null) {
    processedPositions.add(match.index);
  }
  while ((match = markdownLinkRegex.exec(text)) !== null) {
    processedPositions.add(match.index);
  }

  // 匹配纯图片链接的正则表达式
  const imageUrlRegex =
    /https?:\/\/[^\s,]+\.(png|jpe?g|gif|webp|svg|bmp|ico|tiff?)(?:\?[^\s,]*)?/gi;

  let result = text;
  let offset = 0;

  // 处理所有匹配的图片链接
  while ((match = imageUrlRegex.exec(text)) !== null) {
    const originalUrl = match[0];
    const startIndex = match.index;
    const endIndex = startIndex + originalUrl.length;

    // 检查是否在代码块内
    const isInCodeBlock = codeBlockPositions.some(
      (block) => startIndex >= block.start && startIndex < block.end
    );

    // 检查是否在行内代码内
    const isInInlineCode = inlineCodePositions.some(
      (inline) => startIndex >= inline.start && startIndex < inline.end
    );

    // 检查是否在已处理的 markdown 格式内
    let isInMarkdown = false;
    for (const pos of processedPositions) {
      if (startIndex >= pos && startIndex < pos + 50) {
        // 50 是一个估算的 markdown 格式长度
        isInMarkdown = true;
        break;
      }
    }

    // 检查是否为 HTTP 图片链接（在 HTTPS 页面中会被浏览器阻止）
    const isHttpImage = originalUrl.toLowerCase().startsWith("http://");
    const isHttpsPage =
      typeof window !== "undefined" && window.location.protocol === "https:";

    // 只有在不是代码块、行内代码或已有 markdown 格式时才处理
    // 如果是 HTTP 图片且当前页面是 HTTPS，则跳过转换，保持为纯链接
    if (
      !isInCodeBlock &&
      !isInInlineCode &&
      !isInMarkdown &&
      !(isHttpImage && isHttpsPage)
    ) {
      // 转换为 markdown 图片格式
      const markdownImage = `\n![image](${originalUrl})\n`;

      // 计算在结果字符串中的实际位置
      const actualStartIndex = startIndex + offset;
      const actualEndIndex = endIndex + offset;

      // 替换链接
      result =
        result.slice(0, actualStartIndex) +
        markdownImage +
        result.slice(actualEndIndex);

      // 更新偏移量
      offset += markdownImage.length - originalUrl.length;
    }
  }

  return result;
}

// 将 MP4 链接转换为 video 标签
function convertVideoLinksToVideoTag(text: string): string {
  if (typeof text !== "string") return text;

  // 检测 Markdown 代码块位置（```包围的内容）
  const codeBlockRegex = /```[\s\S]*?```/g;
  const codeBlockPositions: Array<{ start: number; end: number }> = [];

  let match;
  while ((match = codeBlockRegex.exec(text)) !== null) {
    codeBlockPositions.push({
      start: match.index,
      end: match.index + match[0].length,
    });
  }

  // 检测行内代码位置（`包围的内容）
  const inlineCodeRegex = /`[^`\n]+`/g;
  const inlineCodePositions: Array<{ start: number; end: number }> = [];

  while ((match = inlineCodeRegex.exec(text)) !== null) {
    inlineCodePositions.push({
      start: match.index,
      end: match.index + match[0].length,
    });
  }

  // 匹配 markdown 链接格式 [text](url)
  const markdownLinkRegex = /\[([^\]]*)\]\(([^)]+)\)/g;
  const processedPositions = new Set<number>();

  // 收集所有 markdown 链接格式的位置
  while ((match = markdownLinkRegex.exec(text)) !== null) {
    processedPositions.add(match.index);
  }

  // 匹配纯视频链接的正则表达式（支持 mp4, webm, ogg 等格式）
  const videoUrlRegex =
    /https?:\/\/[^\s,]+\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv)(?:\?[^\s,]*)?/gi;

  let result = text;
  let offset = 0;

  // 处理所有匹配的视频链接
  while ((match = videoUrlRegex.exec(text)) !== null) {
    const originalUrl = match[0];
    const startIndex = match.index;
    const endIndex = startIndex + originalUrl.length;

    // 检查是否在代码块内
    const isInCodeBlock = codeBlockPositions.some(
      (block) => startIndex >= block.start && startIndex < block.end
    );

    // 检查是否在行内代码内
    const isInInlineCode = inlineCodePositions.some(
      (inline) => startIndex >= inline.start && startIndex < inline.end
    );

    // 检查是否在已处理的 markdown 格式内
    let isInMarkdown = false;
    for (const pos of processedPositions) {
      if (startIndex >= pos && startIndex < pos + 50) {
        isInMarkdown = true;
        break;
      }
    }

    // 只有在不是代码块、行内代码或已有 markdown 格式时才处理
    if (!isInCodeBlock && !isInInlineCode && !isInMarkdown) {
      // 转换为 video 标签
      const videoTag = `\n<video src="${originalUrl}" controls width="100%" style="max-width: 280px; max-height: 280px; margin: 10px 0;"></video>\n`;

      // 计算在结果字符串中的实际位置
      const actualStartIndex = startIndex + offset;
      const actualEndIndex = endIndex + offset;

      // 替换链接
      result =
        result.slice(0, actualStartIndex) +
        videoTag +
        result.slice(actualEndIndex);

      // 更新偏移量
      offset += videoTag.length - originalUrl.length;
    }
  }

  return result;
}
function convertFileLinksToTags(text: string): any {
  if (typeof text !== "string") return [];

  const fileList: any[] = [];
  const addedUrls = new Set<string>();

  // Define supported file extensions
  const fileExtensions = ["xlsx", "xls", "docx", "doc", "pdf", "csv", "html", "txt", "md", "markdown", "mdown"];
  const extensionsPattern = fileExtensions.join("|");

  // Regex pattern for Markdown link format: [name](url)
  const markdownLinkPattern = new RegExp(
    `\\[([^\\]]+)\\]\\((https?://[^\\)]+\\.(?:${extensionsPattern})(?:\\?[^\\)]*)?)\\)`,
    "gi"
  );

  // Extract all Markdown format links using matchAll
  const matches = text.matchAll(markdownLinkPattern);

  for (const match of matches) {
    const name = match[1].trim();
    const url = match[2].trim();
    const originData = match[0]; // Extract original matched string [name](url)

    // Skip duplicate URLs
    if (!addedUrls.has(url)) {
      fileList.push({
        fileDetail: {
          name,
          url,
        },
        originData: originData, // Add original markdown format
      });
      addedUrls.add(url);
    }
  }

  return {
    fileList: fileList,
    text: text,
  };
}
// Get current domain
function getCurrentDomain(): string {
  return window.location.hostname;
}

// Get current domain with protocol
function getCurrentDomainWithProtocol(): string {
  return `${window.location.protocol}//${window.location.hostname}`;
}

// Get current full domain with path
function getCurrentFullDomain(): string {
  return window.location.origin;
}
function judgementShwo() {
  const a = getCurrentFullDomain();
  if (
    a == "https://link-ai.tech" ||
    a == "http://link-ai.tech" ||
    a.includes("test.link-ai.cloud") ||
    a.includes("localhost")
  ) {
    return true;
  }
  return false;
}

// Desktop client download entry point, shared by every console entry.
// Standard LinkAI users land on the portal product page (richer intro, video);
// OEM deployments stay inside the console so no link-ai.tech URL is exposed.
const CLIENT_DOWNLOAD_PORTAL_PATH = "/product/agent#download";
const CLIENT_DOWNLOAD_CONSOLE_PATH = "/console/superagent/download";

function isMobileDevice(): boolean {
  const ua = (navigator.userAgent || "").toLowerCase();
  return (
    /android|iphone|ipod|ipad|iemobile|blackberry|windows phone|mobile/.test(
      ua
    ) ||
    // iPadOS reports a desktop UA; touch points give it away.
    (ua.includes("macintosh") && navigator.maxTouchPoints > 1)
  );
}

function openClientDownload() {
  // The installer only runs on Windows / macOS, so don't hand a phone user a
  // 100+ MB file they can't open.
  if (isMobileDevice()) {
    ElMessage.warning(
      "桌面客户端仅支持 Windows / macOS，请在电脑浏览器中打开下载"
    );
    return;
  }
  if (!judgementShwo()) {
    router.push({ path: CLIENT_DOWNLOAD_CONSOLE_PATH });
    return;
  }
  // Same origin keeps the test environment self-contained; local dev has no
  // portal build, so it falls back to production.
  const origin = getCurrentFullDomain();
  const base = origin.includes("localhost") ? "https://link-ai.tech" : origin;
  window.open(`${base}${CLIENT_DOWNLOAD_PORTAL_PATH}`, "_blank");
}

// Always stays in the console, regardless of OEM. Used by entries where
// leaving the console would be jarring (e.g. the avatar dropdown).
function openClientDownloadPage() {
  if (isMobileDevice()) {
    ElMessage.warning(
      "桌面客户端仅支持 Windows / macOS，请在电脑浏览器中打开下载"
    );
    return;
  }
  router.push({ path: CLIENT_DOWNLOAD_CONSOLE_PATH });
}
/**
 * 格式化耗时，保留1位有效数字
 * @param {number} ms - 毫秒数
 * @returns {string} 格式化后的秒数
 */
function formatDuration(ms: number): string {
  if (ms === 0 || ms === null || ms === undefined) return "0";
  const seconds = ms / 1000;

  if (seconds >= 1) {
    // 大于等于1秒时，保留1位小数
    return seconds.toFixed(1);
  } else {
    // 小于1秒时，保留足够的小数位使得有1位有效数字
    const magnitude = Math.floor(Math.log10(Math.abs(seconds)));
    const decimalPlaces = -magnitude;
    return seconds.toFixed(decimalPlaces);
  }
}

// 输入 tokens 中的缓存部分，如 "缓存命中 2944，缓存写入 31"；无缓存时返回空串
function formatCacheTokens(cacheRead?: number | string, cacheWrite?: number | string): string {
  const parts: string[] = [];
  if (Number(cacheRead) > 0) parts.push(`缓存命中 ${cacheRead}`);
  if (Number(cacheWrite) > 0) parts.push(`缓存写入 ${cacheWrite}`);
  return parts.join('，');
}
/**
 * Get cookie domain from current hostname
 * Extract the main domain and add a dot prefix for subdomain sharing
 */
const getCookieDomain = (): string => {
  const hostname = window.location.hostname

  // If it's localhost or IP address, return as is
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname
  }

  // Extract the main domain (e.g., "www.example.com" -> ".example.com")
  const parts = hostname.split('.')
  if (parts.length >= 2) {
    return `.${parts.slice(-2).join('.')}`
  }

  return hostname
}

const COOKIE_DOMAIN = getCookieDomain()
const COOKIE_PATH = '/'
const TOKEN_COOKIE_KEY = 'TOKEN_KEY'

/**
 * 设置Cookie
 */
const setCookie = (name: string, value: string, days: number = 7): void => {
  const maxAge = days * 24 * 60 * 60
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=${COOKIE_DOMAIN}; path=${COOKIE_PATH}; max-age=${maxAge}; SameSite=Lax`
}
const getCookie = (): string => {
  const match = document.cookie.match(new RegExp('(^| )' + TOKEN_COOKIE_KEY + '=([^;]+)'))
  return match ? decodeURIComponent(match[2] || '') : ''
}

/**
 * Remove cookie by setting max-age to 0
 */
const removeCookie = (name: string): void => {
  document.cookie = `${name}=; domain=${COOKIE_DOMAIN}; path=${COOKIE_PATH}; max-age=0; SameSite=Lax`
}
export {
  addChatData,
  addChatDataforWeb,
  updataBalance,
  isToken,
  weXinlogin,
  extractUrlParams,
  getImageUrl,
  compressionFile,
  downloadFile,
  streamDownload,
  getMp4Url,
  truncateString,
  checkImageExists,
  getRouterName,
  authIsShow,
  showMemberGradeBadge,
  rightJudgment,
  parseMarkdownWithLaTeXHandling,
  deepClone,
  handleConsoleMenuList,
  handlePrivige,
  debounce,
  changeMember,
  convertImageLinksToMarkdown,
  convertVideoLinksToVideoTag,
  getCurrentDomain,
  getCurrentDomainWithProtocol,
  getCurrentFullDomain,
  judgementShwo,
  openClientDownload,
  openClientDownloadPage,
  crossOriginStreamDownload,
  convertFileLinksToTags,
  generateHomeMenuList,
  formatDuration,
  formatCacheTokens,
  setCookie,
  getCookie,
  removeCookie
};
